import NameSpace from '../ns/NameSpace'
import { CsBsKvs, CsBsKvsEventLog, Time as CsBsTime, Timer } from 'csbc-kvslib'
import EventLogModel from './EventLogModel'

/**
 * Kvs通信管理クラス
 */
class KvsManager
{
  // ---------------------------------------------------------------------------------------------------------
  // --	KvsManager
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor()
  {
    console.log('KvsManager')
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	共通
  // ---------------------------------------------------------------------------------------------------------

  /**
   * 初期化（APIのパスを設定）
   */
  init(api_path, server_time)
  {
    console.log('KvsManager.init:' + api_path + ' - ' + server_time)

    //APIのパスを設定
    CsBsKvs.path = api_path

    //時間管理用クラスを生成
    this.time = new CsBsTime(server_time)
  }

  /**
   * 現在の日時を取得
   */
  now()
  {
    return this.time.now()
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	 ログ関連
  // ---------------------------------------------------------------------------------------------------------

  /**
   * 初期設定
   */
  initEventLog(session_id, obj, enabled = true)
  {
    console.log('KvsManager.initEventLog ==========')
    console.log('session_id:', session_id)
    console.log('obj:', obj)
    console.log('enabled:', enabled)

    //ログ送信するかどうか設定
    CsBsKvsEventLog.enabled = enabled
    console.log('CsBsKvsEventLog.enabled:' + CsBsKvsEventLog.enabled)

    //インスタンス生成
    this.csBsKvsEventLog = new CsBsKvsEventLog()
    
    //セッションIDをセット
    this.setSessionID(session_id)

    //イベントログ用の共通データをセット
    this.csBsKvsEventLog.setLogDataCommon(obj)
  }

  /**
   * セッションIDをセット
   */
  setSessionID(session_id)
  {
    this.csBsKvsEventLog.setSessionId(session_id)
  }

  /**
   * ステージ開始
   */
  startStage(contentStage, workNum = 5)
  {
    console.log('===========================')
    console.log('KvsManager.startStage:' + contentStage + ' - workNum:' + workNum)

    if(!this.csBsKvsEventLog)
    {
      console.log('csBsKvsEventLogが生成されていないので分析ログはとりません')
      return
    }

    //ステージ開始時間保存
    this.eventStartAt = this.time.now()

    //ステージ番号
    this.contentStage = contentStage

    //ステージごとのワークの数
    this.workNum = workNum
  }

  /**
   * 振り返り問題開始
   */
  startFurikaeri()
  {
    console.log('===========================')
    console.log('KvsManager.startFurikaeri')

    if(!this.csBsKvsEventLog)
    {
      console.log('csBsKvsEventLogが生成されていないので分析ログはとりません')
      return
    }

    //ステージ開始時間保存
    this.eventStartAt = this.time.now()

    //ステージ番号
    this.contentStage = 0

    //ステージごとのワークの数
    this.workNum = 0
  }

  /**
   * 問題開始
   */
  startQuestion(index)
  {
    console.log('===========================')
    console.log('KvsManager.startQuestion:' + index)

    if(!this.csBsKvsEventLog)
    {
      console.log('csBsKvsEventLogが生成されていないので分析ログはとりません')
      return
    }

    //問題番号やステータスを準備
    const contentQuestionNum = this.workNum * (this.contentStage - 1) + index
    const date = new Date()
    const questionStartAt = date.getTime()

    //モデル生成
    this.model = new EventLogModel(this.contentStage, contentQuestionNum, questionStartAt)
    console.log(this.model)
  }

  /**
   * 回答
   */
  answerQuestion(contentAnswer = '', contentResult = 1)
  {
    console.log('KvsManager.answerQuestion:' + contentAnswer + ' - ' + contentResult)

    if(!this.csBsKvsEventLog)
    {
      console.log('csBsKvsEventLogが生成されていないので分析ログはとりません')
      return
    }

    this.model.contentAnswer = contentAnswer
    this.model.contentResult = contentResult
    this.model.accessDt = this.time.now()
  }

  /**
   * 問題終了
   */
  finishQuestion()
  {
    console.log('KvsManager.finishQuestion')
    
    if(!this.csBsKvsEventLog)
    {
      console.log('csBsKvsEventLogが生成されていないので分析ログはとりません')
      return
    }

    //終了時間を保持
    const date = new Date()
    this.model.questionEndAt = date.getTime()

    //ログを追加
    this.csBsKvsEventLog.pushLogData(
      `T${this.model.accessDt}`, this.model.data,
    )
    console.log(this.model.data)
    this.model = null
  }

  /**
   * ステージ終了（ログを保存）
   */
  finishStage(isPerfect)
  {
    console.log('KvsManager.finishStage:', isPerfect)
    return this.postLog((isPerfect)?2:1)
  }

  /**
   * 振り返り終了
   */
  finishFurikaeri()
  {
    console.log('KvsManager.finishFurikaeri')
    return this.postLog()
  }

  /**
   * ログを送信
   */
  postLog(contentStatus = 0)
  {
    //ステージ終了時間を保持
    const eventEndat = this.time.now()

    //上書き用データ
    const log = {}
    if(contentStatus > 0) log.contentStatus = String(contentStatus)
    log.eventStartAt = this.eventStartAt
    log.eventEndat = eventEndat
    log.eventNum = eventEndat

    //これまでに登録したデータに共通のデータを上書き
    this.csBsKvsEventLog.applyLogDataAll(log)

    // 内容を確認
    console.log(this.csBsKvsEventLog.toString())

    return this.csBsKvsEventLog.post()
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	UTIL
  // ---------------------------------------------------------------------------------------------------------

  /**
   * 問題回答済みかどうかを判定
   */
  isAnswered()
  {
    if(this.model)
    {
      return (this.model.accessDt)
    }
    else
    {
      return false
    }
  }


  /**
   * ログをクリアする
   */
  clearLogData()
  {
    this.csBsKvsEventLog.clearLogData()
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	デバッグ用
  // ---------------------------------------------------------------------------------------------------------

  /**
   * DBデータ削除
   */
  deleteAll()
  {
    return this.csBsKvsHiraganaQuiz.deleteAll()
  }


  // ---------------------------------------------------------------------------------------------------------
}

if(!NameSpace.getNameSpace('okawari.common.kvs').KvsManager)
  NameSpace.getNameSpace('okawari.common.kvs').KvsManager = new KvsManager()
export default NameSpace.getNameSpace('okawari.common.kvs').KvsManager